import {
    VStack,
    HStack,
    Text,
    Progress,
    Box,
} from "@chakra-ui/react";

import Card from "./Card";

const FunnelCard = ({
    drivers = [],
    milestones = [],
}) => {
const registered =
    drivers.filter(
        driver =>
            driver.driver
                ?.driver_id
    ).length;
const approved =
    drivers.filter(
        driver =>
            driver.driver
                ?.status ===
            "Approved"
    ).length;


    const firstDelivery =
        new Set(
            milestones
                .filter(
                    (
                        milestone
                    ) =>
                        milestone.milestone_type ===
                     "First Delivery Completed" &&
                        milestone.milestone_status ===
                            "Achieved"
                )
                .map(
                    (
                        milestone
                    ) =>
                        milestone.driver_id
                )
        ).size;
    
    const tenDeliveries =
    new Set(
        milestones
            .filter(
                (
                    milestone
                ) =>
                   milestone.milestone_type ===
    "Ten Deliveries Completed" &&
                    milestone.milestone_status ===
                        "Achieved"
            )
            .map(
                (
                    milestone
                ) =>
                    milestone.driver_id
            )
    ).size;

    const thirtyDeliveries =
        new Set(
            milestones
                .filter(
                    (
                        milestone
                    ) =>
                       milestone.milestone_type ===
    "Thirty Deliveries Completed" &&
                        milestone.milestone_status ===
                            "Achieved"
                )
                .map(
                    (
                        milestone
                    ) =>
                        milestone.driver_id
                )
        ).size;

    const registeredToApproved =
        registered > 0
            ? Math.round(
                  (
                      approved /
                      registered
                  ) *
                      100
              )
            : 0;

    const approvedToFirstDelivery =
        approved > 0
            ? Math.round(
                  (
                      firstDelivery /
                      approved
                  ) *
                      100
              )
            : 0;

const firstToTen =
    firstDelivery > 0
        ? Math.round(
              (
                  tenDeliveries /
                  firstDelivery
              ) * 100
          )
        : 0;

const tenToThirty =
    tenDeliveries > 0
        ? Math.round(
              (
                  thirtyDeliveries /
                  tenDeliveries
              ) * 100
          )
        : 0;

const steps = [
    {
        label: "Registered → Approved",
        value:
            registeredToApproved,
    },
    {
        label: "Approved → 1st Delivery",
        value:
            approvedToFirstDelivery,
    },
    {
        label: "1st → 10 Deliveries",
        value: firstToTen,
    },
    {
        label: "10th → 30th Delivery",
        value: tenToThirty,
    },
];

const averageHealth =
    (
        registeredToApproved +
        approvedToFirstDelivery +
        firstToTen +
        tenToThirty
    ) / 4;

    const healthLabel =
        averageHealth >= 75
            ? "Excellent"
            : averageHealth >= 50
            ? "Good"
            : averageHealth >= 30
            ? "Fair"
            : "Poor";

    const healthColor =
        averageHealth >= 75
            ? "green.600"
            : averageHealth >= 50
            ? "blue.600"
            : averageHealth >= 30
            ? "orange.600"
            : "red.600";

    return (
        <Card h="100%">
            <Text
                fontWeight="700"
                fontSize="xl"
                mb={6}
            >
                Conversion Funnel
            </Text>

            <VStack
                align="stretch"
                gap={5}
            >
                {steps.map(
                    (
                        step
                    ) => (
                        <Box
                            key={
                                step.label
                            }
                        >
                            <HStack
                                justify="space-between"
                                mb={2}
                            >
                                <Text fontSize="sm">
                                    {
                                        step.label
                                    }
                                </Text>

                                <Text
                                    color="#2453FF"
                                    fontWeight="700"
                                >
                                    {
                                        step.value
                                    }
                                    %
                                </Text>
                            </HStack>

                            <Progress.Root
                                value={
                                    step.value
                                }
                            >
                                <Progress.Track
                                    bg="#EEF4FF"
                                    borderRadius="full"
                                >
                                    <Progress.Range
                                        bg="#2453FF"
                                    />
                                </Progress.Track>
                            </Progress.Root>
                        </Box>
                    )
                )}
            </VStack>

            <Box
                mt={8}
                bg="#F4F7FC"
                borderRadius="14px"
                py={5}
                textAlign="center"
            >
                <Text
                    fontSize="xs"
                    color="gray.500"
                    fontWeight="700"
                >
                    TOP FUNNEL HEALTH
                </Text>

                <Text
                    mt={2}
                    fontSize="3xl"
                    fontWeight="700"
                    color={
                        healthColor
                    }
                >
                    {
                        healthLabel
                    }
                </Text>

                <Text
                    mt={1}
                    fontSize="sm"
                    color="gray.500"
                >
                    {Math.round(
                        averageHealth
                    )}
                    % average conversion
                </Text>
            </Box>
        </Card>
    );
};

export default FunnelCard;